import { colors } from '../../colors';
var accordion = {
  bodyBackgroundColor: colors.white,
  iconColor: colors.copper,
  rowBackgroundColor: colors.overcast,
  textColorDark: colors.lead,
  textColorLight: colors.white
};
export default accordion;